import ProfileVue from '@/views/sa/profile/profileComponent.vue';

const basePath = '/sa/profile';
const role = 'sa'; // 角色身份

export const SA_PROFILE_INDEX = 'sa-profile-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ProfileVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_PROFILE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/profile/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
